// import api from '@/api/api'
import axios from '@/api/api.js'
import { queryOptions } from '@tanstack/react-query'
import {
  ADD_DICTIONARY_DETAIL,
  DELETE_DICTIONARY_DETAIL,
  GET_ALL_DICTIONARY_DETAILS,
  GET_DICTIONARY_DETAILS,
  UPDATE_DICTIONARY_DETAIL,
  UPDATE_DICTIONARY_DETAILS
} from '@/api/endpoints/dictionaryControllerEndpoints.js'

export default function containerOptions() {
  return queryOptions({
    queryKey: ['containers'],
    queryFn: () => getDictionaryDetails('CONTAINER'),
    staleTime: 1000 * 60 * 5, // 5 minutes
    cacheTime: 1000 * 60 * 30, // 30 minutes
    refetchOnWindowFocus: false // Disable refetching on window focus
  })
}

// Container LOV
export const getDictionaryDetails = async dictionaryCode1 => {
  try {
    const response = await axios.post(GET_DICTIONARY_DETAILS, {
      dictionaryCode1
    })
    return response.data
  } catch (error) {
    console.error(`Error fetching getDictionaryDetails data for ${dictionaryCode1}: `, error)
    throw error
  }
}

export const getAllDictionaryDetails = async () => {
  try {
    const response = await axios.get(GET_ALL_DICTIONARY_DETAILS)
    return response.data
  } catch (error) {
    console.error(`Error fetching getAllDictionaryDetails data `, error)
    throw error
  }
}

export const addDictionaryDetails = async data => {
  try {
    const response = await axios.post(ADD_DICTIONARY_DETAIL, data)
    return response.data
  } catch (error) {
    console.error(`Error in adding dictionary details`, error)
    throw error
  }
}

export const updateDictionaryDetails = async data => {
  try {
    const response = await axios.post(UPDATE_DICTIONARY_DETAIL, data)
    return response.data
  } catch (error) {
    console.error(`Error in updating the dictionary details `, error)
    throw error
  }
}

export const updateDictionaryListDetails = async data => {
  try {
    const response = await axios.post(UPDATE_DICTIONARY_DETAILS, data)
    return response.data
  } catch (error) {
    console.error(`Error in updating the dictionary details `, error)
    throw error
  }
}

export const deleteDictionaryDetails = async data => {
  try {
    const response = await axios.post(DELETE_DICTIONARY_DETAIL, data)
    return response.data
  } catch (error) {
    console.error(`Error in deleting the dictionary details `, error)
    throw error
  }
}

//export const getproducts = getDictionaryDetails('PRODUCTS')
